export default __webpack_public_path__ + "static/media/meri-logo.ede3e344.svg";